import type { PublicLocale } from "../../../lib/public-locale";

export type IndustryId =
  | "restaurants"
  | "salons-spas"
  | "hotels"
  | "healthcare"
  | "retail";
export type Localized = Readonly<Record<PublicLocale, string>>;
export const words = (en: string, fr: string, ar: string): Localized => ({
  en,
  fr,
  ar,
});

export const industryNavigation: ReadonlyArray<{
  id: IndustryId;
  name: Localized;
  short: Localized;
  summary: Localized;
}> = [
  {
    id: "restaurants",
    name: words("Restaurants", "Restaurants", "المطاعم"),
    short: words("Restaurant", "Restaurant", "مطعم"),
    summary: words(
      "Reviews · Local SEO · WhatsApp",
      "Avis · SEO local · WhatsApp",
      "التقييمات · الظهور المحلي · WhatsApp",
    ),
  },
  {
    id: "salons-spas",
    name: words("Salons & Spas", "Salons & Spas", "الصالونات والسبا"),
    short: words("Salon", "Salon", "صالون"),
    summary: words(
      "Bookings · Reputation · Loyalty",
      "Rendez-vous · Réputation · Fidélité",
      "المواعيد · السمعة · الولاء",
    ),
  },
  {
    id: "hotels",
    name: words(
      "Hotels & Hospitality",
      "Hôtels & Hôtellerie",
      "الفنادق والضيافة",
    ),
    short: words("Hotel", "Hôtel", "فندق"),
    summary: words(
      "Reviews · Guest experience",
      "Avis · Expérience client",
      "التقييمات · تجربة الضيوف",
    ),
  },
  {
    id: "healthcare",
    name: words("Healthcare & Clinics", "Santé & Cliniques", "الصحة والعيادات"),
    short: words("Healthcare", "Santé", "صحة"),
    summary: words(
      "Local trust · Patient reviews",
      "Confiance locale · Avis patients",
      "الثقة المحلية · تقييمات المرضى",
    ),
  },
  {
    id: "retail",
    name: words("Retail", "Commerce", "التجارة"),
    short: words("Retail", "Commerce", "متجر"),
    summary: words(
      "Locations · Traffic · Reputation",
      "Établissements · Trafic · Réputation",
      "الفروع · الزيارات · السمعة",
    ),
  },
];
export const navigationCopy = {
  title: words(
    "Every business has its own rhythm.",
    "Chaque activité a son rythme.",
    "لكل نشاط إيقاعه الخاص.",
  ),
  subtitle: words(
    "One engine. Built for yours.",
    "Un moteur. Adapté au vôtre.",
    "محرك واحد. مصمم لإيقاعك.",
  ),
  all: words(
    "Explore all industries",
    "Explorer tous les secteurs",
    "استكشاف جميع القطاعات",
  ),
};
